import { Menu, Avatar } from '@mantine/core';
import { IconLogout, IconUser } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';
import { User } from '../types/auth';
import { useAuth } from '../hooks/useAuth';

interface ProfileMenuProps {
  user: User;
}

export function ProfileMenu({ user }: ProfileMenuProps) {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  return (
    <Menu shadow="md" width={200}>
      <Menu.Target>
        <Avatar
          src={null}
          alt={user.name}
          color="blue"
          style={{ cursor: 'pointer' }}
        >
          {user.name.charAt(0)}
        </Avatar>
      </Menu.Target>

      <Menu.Dropdown>
        <Menu.Label>Account</Menu.Label>
        <Menu.Item
          icon={<IconUser size={14} />}
          onClick={() => navigate('/profile')}
        >
          Profile
        </Menu.Item>
        <Menu.Item
          icon={<IconLogout size={14} />}
          onClick={handleLogout}
        >
          Logout
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
}